// extracted by mini-css-extract-plugin
export default {"homeTitle":"c-a_fR","homeTitle_styleDefault":"c-a_fS","homeTitle_styleRed":"c-a_fT"};